import { render, staticRenderFns } from "./no_access.vue?vue&type=template&id=b7e1b96c&scoped=true"
import script from "./no_access.vue?vue&type=script&lang=js"
export * from "./no_access.vue?vue&type=script&lang=js"
import style0 from "./no_access.vue?vue&type=style&index=0&id=b7e1b96c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e1b96c",
  null
  
)

export default component.exports